/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_SomeoneInputs */

const en_follow_someone = /** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Someone`)
};

const es_follow_someone = /** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguien`)
};

const fr_follow_someone = /** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelqu'un`)
};

const de_follow_someone = /** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jemand`)
};

const id_follow_someone = /** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seseorang`)
};

/** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */
const ja_follow_someone = en_follow_someone;

/** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */
const zh_follow_someone = en_follow_someone;

/** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */
const ar_follow_someone = en_follow_someone;

/** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */
const it_follow_someone = en_follow_someone;

/** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */
const ru_follow_someone = en_follow_someone;

/** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */
const pt_follow_someone = en_follow_someone;

/** @type {(inputs: Follow_SomeoneInputs) => LocalizedString} */
const ko_follow_someone = en_follow_someone;

/**
* | output |
* | --- |
* | "Someone" |
*
* @param {Follow_SomeoneInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_someone = /** @type {((inputs?: Follow_SomeoneInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_SomeoneInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_someone(inputs)
	if (locale === "es") return es_follow_someone(inputs)
	if (locale === "fr") return fr_follow_someone(inputs)
	if (locale === "de") return de_follow_someone(inputs)
	if (locale === "ja") return ja_follow_someone(inputs)
	if (locale === "zh") return zh_follow_someone(inputs)
	if (locale === "ar") return ar_follow_someone(inputs)
	if (locale === "id") return id_follow_someone(inputs)
	if (locale === "it") return it_follow_someone(inputs)
	if (locale === "ru") return ru_follow_someone(inputs)
	if (locale === "pt") return pt_follow_someone(inputs)
	return ko_follow_someone(inputs)
});